/**
 * Shared React Query keys for the law enforcement command center.
 * Use these when invalidating or prefetching so they stay consistent with the page.
 */
export const lawEnforcementCommandCenterQueryKeys = {
  adminContacts: (dayOfEmergencyId: string, token: string) =>
    [...lawEnforcementCommandCenterQueryKeys.root, "admin-contacts", dayOfEmergencyId, token] as const,
  bubbleContext: (dayOfEmergencyId: string, token: string) =>
    [...lawEnforcementCommandCenterQueryKeys.root, "bubble-context", dayOfEmergencyId, token] as const,
  day: (dayOfEmergencyId: string, token: string) =>
    [...lawEnforcementCommandCenterQueryKeys.root, "day", dayOfEmergencyId, token] as const,
  declarations: (dayOfEmergencyId: string, token: string) =>
    [...lawEnforcementCommandCenterQueryKeys.root, "declarations", dayOfEmergencyId, token] as const,
  participants: (dayOfEmergencyId: string, token: string) =>
    [...lawEnforcementCommandCenterQueryKeys.root, "participants", dayOfEmergencyId, token] as const,
  root: ["law-enforcement-command-center"] as const,
  timeline: (dayOfEmergencyId: string, token: string) =>
    [...lawEnforcementCommandCenterQueryKeys.root, "timeline", dayOfEmergencyId, token] as const,
  validate: (dayOfEmergencyId: string, token: string) =>
    [...lawEnforcementCommandCenterQueryKeys.root, "validate", dayOfEmergencyId, token] as const,
};
